import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { FormFieldApi } from '../types';

export interface TextFieldProps<TValue = string> extends Omit<MuiTextFieldProps, 'name' | 'onChange' | 'onBlur' | 'value' | 'error'> {
  field: FormFieldApi<TValue>;
  name: string;
}

/**
 * TextField component that integrates with TanStack Form
 */
export const TextField = <TValue = string,>({
  field,
  name,
  helperText,
  ...props
}: TextFieldProps<TValue>) => {
  const { state, getMeta } = field;
  const meta = getMeta();
  const error = meta.touchedErrors.length > 0;
  const errorMessage = meta.touchedErrors[0] as string | undefined;

  return (
    <MuiTextField
      name={name}
      value={(state.value ?? '') as string}
      onChange={(e) => field.handleChange(e.target.value as TValue)}
      onBlur={() => field.handleBlur()}
      error={error}
      helperText={error ? errorMessage : helperText}
      fullWidth
      {...props}
    />
  );
}; 